export const refreshStatusNames = {
  idle: 'Idle',
  queued: 'Queued',
  updating: 'Updating',
  error: 'Error',
};

export const refreshStatuses = {
  0: refreshStatusNames.idle,
  1: refreshStatusNames.queued,
  2: refreshStatusNames.updating,
  3: refreshStatusNames.error,
};
